export enum MutationTypes {
  Swap = 'Swap',
  AddIngredient = 'AddIngredient',
  RemoveIngredient = 'RemoveIngredient',
}
